module.exports = __webpack_public_path__ + "img/visa.552658be.svg";